let faq = {
    init: function () {
        faq.contentSkip();
        faq.handleAccordion();
    },

    contentSkip: function () {
        $(document).on('click', '.page-template-template-faq .skip-navigation', function (e) {
            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: $('.category__filters').offset().top - 50,
                },
                1000
            );
        });
    },
    handleAccordion: function () {
        const faqItems = document.querySelectorAll('.page-template-template-faq-new .faq-accordion__item');

        faqItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                let answer = item.querySelector('.faq-accordion__answer');
                answer.addEventListener(
                    'click',
                    (e) => {
                        if (e.target.hasAttribute('href')) {
                            e.stopImmediatePropagation();
                        } else {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    },
                    true
                );

                let content = e.currentTarget;

                if (content.classList.contains('open')) {
                    content.classList.remove('open');
                    return;
                }

                const open = document.querySelectorAll('.page-template-template-faq-new .faq-accordion__item.open');

                open.forEach((item) => {
                    item.classList.remove('open');
                });

                content.classList.toggle('open');
            });
        });
    },
};

$(document).ready(function () {
    faq.init();
});
